import React, { useState } from 'react';
import { useTransactionGridContext } from './TransactionGridContext';
import { TransactionAsset, TransactionEntity } from './types';
import { TRANSACTION_TYPE } from '../types';
import { formatCurrency, formatDate } from '../common/utils';
import { AccountTransactionDescription, TransactionLoadingSkeleton } from './index';

const amountClass = {
    [TRANSACTION_TYPE.WITHDRAWAL]:         'neg',
    [TRANSACTION_TYPE.DEPOSIT]:            'pos-blue',
    [TRANSACTION_TYPE.AFFILIATE_PURCHASE]: 'pos-green',
    [TRANSACTION_TYPE.PURCHASE]:           'neg-blue',
    [TRANSACTION_TYPE.SURVEY]:             'pos-green',
    [TRANSACTION_TYPE.PAYMENT_REQUEST]:    'neg-blue',
};

const amountSign = {
    [TRANSACTION_TYPE.WITHDRAWAL]:         '−',
    [TRANSACTION_TYPE.DEPOSIT]:            '+',
    [TRANSACTION_TYPE.AFFILIATE_PURCHASE]: '+',
    [TRANSACTION_TYPE.PURCHASE]:           '−',
    [TRANSACTION_TYPE.SURVEY]:             '+',
    [TRANSACTION_TYPE.PAYMENT_REQUEST]:    '-',
};

const PAGE_SIZE = 6;

const TransactionGrid = () => {
    const { transactions } = useTransactionGridContext();
    const [page, setPage] = useState(0);

    const totalPages = Math.ceil((transactions?.length ?? 0) / PAGE_SIZE);
    const paginated = transactions?.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE) ?? [];
    
    return (
        <>
            <div className="tx-section">
                <div className="section-header">
                    <div>
                        <div className="section-title">Recent Activity</div>
                    </div>
                </div>

                <div className="tx-header-row">
                    <span>Asset</span>
                    <span>Amount</span>
                    <span>Type</span>
                    <span>Description</span>
                    <span>Date</span>
                </div>

                {transactions == null ? <TransactionLoadingSkeleton /> : null}

                {paginated.map((tx, index) => {
                    const globalIndex = page * PAGE_SIZE + index;

                    return (
                        <div
                            key={globalIndex}
                            className={'tx-row'}
                        >
                            <span>
                                <span className={'asset-pill asset-cash'}>
                                    {tx.asset}
                                </span>
                            </span>
                            <span className={`tx-amount ${tx.xTransactionEntity == TransactionEntity.IMPACT ? 'pos-blue' : amountClass[tx.type]}`}>
                                {amountSign[tx.type] + (tx.asset == TransactionAsset.CASH ? formatCurrency(tx.amount) : tx.amount )}
                            </span>
                            <span>
                                <span className={`type-pill type-${tx.type.toLowerCase().replace(' ', '-')}`}>
                                    {tx.type}
                                </span>
                            </span>
                            <span className="tx-desc"><AccountTransactionDescription transaction={tx} /></span>
                            <span className="tx-date">{formatDate(tx.timestamp)}</span>
                        </div>
                    );
                })}

                {totalPages > 1 && (
                    <div className="tx-pagination">
                        <button
                            className="tx-page-btn"
                            onClick={() => setPage(p => p - 1)}
                            disabled={page === 0}
                        >
                            ←
                        </button>
                        <span className="tx-page-label">
                            {page + 1} / {totalPages}
                        </span>
                        <button
                            className="tx-page-btn"
                            onClick={() => setPage(p => p + 1)}
                            disabled={page === totalPages - 1}
                        >
                            →
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};

export default TransactionGrid;